import BigHero from "./BigHero";

export default BigHero;
